import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import queryString from "query-string";

import { PAGE_TYPE, setPageTitle, getIsGoogleMode } from "containers/App/reducer";

import * as loginReducer from "containers/Login/reducer";
import * as accountsReducer from "containers/Accounts/reducer";
import * as helpReducer from "containers/Help/reducer";

import { initShareChatApp } from "containers/ChatApp/reducer";

import Login from "components/Login/Login";
import * as chatAppReducer from "containers/ChatApp/reducer";

class LoginContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    props.updateIsLoggedOn(false);

    const queryParams = this.props.location.search;
    if (queryParams) {
      const paramsObj = queryString.parse(queryParams);
      if (typeof paramsObj === "object") {
        if (paramsObj.token && paramsObj.password) {
          this.props.handleLogin(null, paramsObj.password, paramsObj.token);
        }
        if (paramsObj.return_to) {
          try {
            const rawUrl = paramsObj.return_to;
            const url = decodeURIComponent(rawUrl);
            this.props.updateLoginRedirect(url);
          } catch (e) {
            console.log(e);
          }
        }
      }
    }
  }

  componentDidMount() {
    const { uiState, initShareChatApp } = this.props;

    setPageTitle(PAGE_TYPE.LOGIN);

    if (uiState?.type === "SHARE_LINK") {
      initShareChatApp(uiState);
    }
  }

  render() {
    const { match } = this.props;
    const type = match && match.params && match.params.type && String(match.params.type).toLowerCase();
    return (
      <React.Fragment>
        <Login {...this.props} type={type} />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const queryParams = ownProps.location.search;
  const paramsObj = queryString.parse(queryParams);

  const uiState = paramsObj?.["ui-state"];
  return {
    initShareChatApp: (uiState) => dispatch(initShareChatApp(uiState)),
    shareWithNewUser: (email) => dispatch(chatAppReducer.shareWithNewUser(email, uiState)),
    handleLogin: (username, password, token) => dispatch(loginReducer.handleLogin(username, password, token, uiState)),
    handleLogout: () => dispatch(loginReducer.handleLogout({ redirect: false })),
    updateLoginRedirect: (val) => dispatch(loginReducer.updateLoginRedirect(val)),
    selectTenant: (tenant) => dispatch(loginReducer.selectTenant(tenant)),
    resetTenants: () => dispatch(loginReducer.resetTenants()),

    updateIsLoggedOn: (isLoggedOn) => dispatch(loginReducer.updateIsLoggedOn(isLoggedOn)),

    updateIsCreated: (val = false) => dispatch(loginReducer.updateIsCreated(val)),

    updateAccounts: (selectedAccount) => dispatch(accountsReducer.updateAccounts(selectedAccount)),

    getHasAcceptedToS: (email) => dispatch((dispatch, getState) => loginReducer.getHasAcceptedToS(getState(), email)),

    handleRedirect: (uri) => helpReducer.openUri(uri, true),

    registerLooker: () => dispatch(loginReducer.registerLooker())
  };
};

const mapStateToProps = (state, ownProps) => {
  const queryParams = ownProps.location.search;
  let isCreated, email, uiState;
  const paramsObj = queryString.parse(queryParams);
  if (typeof paramsObj === "object") {
    if (paramsObj.email) {
      email = paramsObj.email;
    }
    if (paramsObj.userCreated) {
      isCreated = true;
    }
    if (paramsObj?.["ui-state"]) {
      uiState = chatAppReducer.decodeUiState(paramsObj?.["ui-state"]);
    }
  }
  return {
    uiState: uiState,
    isLoading: loginReducer.getIsLoading(state),
    isCreated: loginReducer.getIsCreated(state) || isCreated,
    isLoggedOn: loginReducer.getIsLoggedOn(state),
    error: loginReducer.getError(state),
    tenants: loginReducer.getTenants(state),
    email: email,
    isDellDomain: loginReducer.getIsDellDomain(),
    domainRedirect: loginReducer.getDomainRedirect(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(LoginContainer);
